import * as BaseContainer from './BaseContainer';
export default BaseContainer.create();